/**
 * Ids of clients that need per-client hardcoded settings. Needed because both the
 * asset map and the i18n files are picked by `environment.name`, and the `smart`
 * environment is multitenant.
 */
export const ClientIds = {
  cement: '1d759d3d-4801-44b1-8ca0-7391c2e9bd23',
  fightingSpirit: '85e192d9-9b47-4100-8645-a9df87911608',
} as const;

/** Support address shown in the footer, taking precedence over `footer.email`. */
export const clientContactEmails: Record<string, string> = {
  [ClientIds.fightingSpirit]: 'marketing@fighting.fr',
};
